import { Navigate, useLocation } from "react-router-dom";

/**
 * =====================================================
 * PROTECTED ROUTE
 * =====================================================
 * ✔ Verifica autenticación
 * ✔ Verifica token JWT
 * ✔ Verifica roles permitidos
 * ✔ Limpia sesión corrupta
 * ✔ Conserva ruta origen
 * =====================================================
 */

export default function ProtectedRoute({
  children,
  roles = [],
}) {
  const location = useLocation();

  /**
   * =====================================================
   * GET AUTH DATA
   * =====================================================
   */

  const authString = localStorage.getItem("auth");

  if (!authString) {
    return (
      <Navigate
        to="/login"
        replace
        state={{ from: location }}
      />
    );
  }

  /**
   * =====================================================
   * PARSE AUTH
   * =====================================================
   */

  let auth;

  try {
    auth = JSON.parse(authString);
  } catch (error) {
    console.error(
      "ProtectedRoute auth parse error:",
      error
    );

    localStorage.removeItem("auth");
    localStorage.removeItem("access");
    localStorage.removeItem("refresh");

    return (
      <Navigate
        to="/login"
        replace
        state={{ from: location }}
      />
    );
  }

  /**
   * =====================================================
   * VALIDATE JWT
   * =====================================================
   */

  const accessToken = auth?.access;
  const user = auth?.user;

  if (!accessToken || !user) {
    localStorage.removeItem("auth");
    localStorage.removeItem("access");
    localStorage.removeItem("refresh");

    return (
      <Navigate
        to="/login"
        replace
        state={{ from: location }}
      />
    );
  }

  /**
   * =====================================================
   * VALIDATE ROLE
   * =====================================================
   */

  const userRole = user?.role;

  if (
    roles.length > 0 &&
    !roles.includes(userRole)
  ) {
    return (
      <Navigate
        to="/"
        replace
      />
    );
  }

  /**
   * =====================================================
   * ACCESS GRANTED
   * =====================================================
   */

  return children;
}